import React from 'react'
import { serverData } from '../../utils'
import { SecondaryHeader } from '../../components'
import FaceScan from './face-scan'
import ShoppingSetting from '../settings/shopping-setting'

const TetherId = ({ onSectionClick }) => {
  const { selectedSubComponent } = serverData

  const SubComponent = {
    facescan: <FaceScan />,
    shoppingsetting: <ShoppingSetting onSectionClick={onSectionClick} />,
  }

  return (
    <SecondaryHeader selectedTabId="privacyLink" selectedTabIndex={2}>
      {SubComponent[selectedSubComponent]}
    </SecondaryHeader>
  )
}

export default TetherId
